import dayjs from 'dayjs';
import Image from 'next/image';
import Link from 'next/link';
import type { RouterOutputs } from '@/server/callers/client';
import { getFileUrl, getPostUrl } from '@/utils/helpers';
import { cn } from '@/utils/utils';

interface PostCardProps extends React.HTMLAttributes<HTMLAnchorElement> {
  post: RouterOutputs['posts']['infinity']['data'][number];
}

export default function PostCard({ post, className, ...props }: PostCardProps) {
  return (
    <Link
      href={getPostUrl(post.slug, post.type)}
      className={cn('block relative group', className)}
      {...props}
    >
      <div className="aspect-[3/2] w-[350px] relative overflow-hidden rounded-4xl">
        <Image
          fill
          src={getFileUrl(post.cover?.key, 'image')}
          alt={post.title}
          className="object-cover transition-transform duration-300 group-hover:scale-110"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent pointer-events-none" />

        <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
          <span className="inline-block text-xs font-semibold bg-yellow-500 text-black px-3 py-1 rounded-full mb-2">
            {post.type}
          </span>
          <h3 className="text-xl font-medium mb-1 line-clamp-2">{post.title}</h3>
          <p className="text-sm text-gray-200">
            {dayjs(post.createdAt).format('MMMM D, YYYY')}
          </p>
        </div>
      </div>
    </Link>
  );
}
